import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Function to simulate an improving NPS score over time
const generateData = () => {
    const data = [];
    let currentValue = 30; // Starting score
    for (let i = 1; i <= 12; i++) {
        const increment = Math.round(Math.random() * 5) + 2; // Small, steady improvements
        currentValue = Math.min(100, currentValue + increment); // Cap max value at 100
        data.push({ month: `Month ${i}`, NPS: currentValue });
    }
    return data;
};

const data = generateData();

const NPSLineChart = () => (
  <LineChart width={800} height={300} data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="month" />
    <YAxis domain={[0, 100]} /> {/* Ensure Y axis is capped at 100 */}
    <Tooltip />
    <Legend />
    <Line type="monotone" dataKey="NPS" stroke="#82ca9d" activeDot={{ r: 8 }} />
  </LineChart>
);

export default NPSLineChart;